import * as React from "react";
import Breadcrumb from "../components/breadcrumb";
import SList from "../components/shopping-list/slist";
import ProductList from "../components/shopping-list/product-list";
import Layout from "../layout/layout";
export default class ShoppingList extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let NavList = [
            { Text: 'Shopping List', Link: '' }
        ];
        let Products = this.props.products;
        let view = !this.props.toggleMobile ? React.createElement("div", { className: "shopping-content" },
            React.createElement(SList, { products: Products }),
            React.createElement(ProductList, { products: Products })) :
            React.createElement("div", { className: "shopping-content mobile-only" },
                React.createElement(ProductList, { products: Products }));
        return (React.createElement(Layout, { route: "" },
            React.createElement("div", { className: "shopping-list" },
                React.createElement(Breadcrumb, { NavList: NavList }),
                React.createElement("h5", { className: "shopping-subheader" }, "ALL OF YOUR FAVOURITES"),
                React.createElement("h1", { className: "shopping-header" }, "MY SHOPPING LIST"),
                React.createElement("div", { className: "shopping-filter-toggle" },
                    React.createElement("div", { className: !this.props.toggleMobile ? "active" : "", onClick: () => this.props.updateToggle(false) }, "Grid"),
                    React.createElement("div", { className: this.props.toggleMobile ? "active" : "", onClick: () => this.props.updateToggle(true) }, "List")),
                view)));
    }
}
;
//# sourceMappingURL=shopping-list.js.map